import http from "./api";

const travelApi = {
  getTravelBranding: (identifier: string) => http.get<{ logoKey?: string | null }>(`/travels/branding/${encodeURIComponent(identifier)}`),
  getCurrentUserParticipations: () => http.get<UserParticipationBasicItemList>(`/travels/participations`),
  getParticipation: (id: number) => http.get<UserParticipation>(`/travels/${id}/participation`),
  getParticipationBySlug: (slug: string) => http.get<UserParticipation>(`/travels/slug/${slug}/participation`),
  saveParticipation: (id: number, data: UserParticipation) => http.put<UserParticipation>(`/travels/${id}/participation`, data),
  createPaymentIntent: (id: number) => http.post<PaymentIntentResponse>(`/travels/${id}/participation/payment/intent`),
  synchronizePayment: (id: number) => http.post<UserParticipationPayment>(`/travels/${id}/participation/payment/sync`),
  saveRefusal: (id: number, reason: string | null | undefined) => http.put<UserParticipation>(`/travels/${id}/participation/refusal`, { reason }),
  saveRefusalBySlug: (slug: string, reason: string | null | undefined) => http.put<UserParticipation>(`/travels/slug/${slug}/participation/refusal`, { reason }),

  searchTravelParticipants: (id: number, query: string, limit = 10) => http.get<ParticipantBasic[]>(`/travels/${id}/participants/search`, { params: { search: query, limit: limit } }),

  validateInvitation: (magicLink: string) => http.get<InvitationValidationResponse>(`/invitation/validate/${magicLink}`, { headers: { "X-Magic-Link": magicLink } }),

  initiateSignature: (travelId: number) => http.post<UserParticipationSignature>(`/travels/${travelId}/participation/signature`),

  getTravelMessages: (id: number) => http.get<UserTravelMessages>(`/travels/${id}/travel-messages`),
  getTravelDocumentInstructions: (id: number) => http.get<UserDocumentInstruction[]>(`/travels/${id}/document-instructions`),
  getTravelPages: (id: number) => http.get<UserTravelPage[]>(`/travels/${id}/pages-content`),

};

export default travelApi;
